import { UserQuestions } from "../UserQuestions";
import { Typography } from "../../UI/Typography";
import { Grid } from "../../UI/Grid";

interface IProps {
  questionsSaved: boolean;
}

export const LifestyleResponsesTree: React.FC<IProps> = ({questionsSaved}) => (
  <Grid container>
    <Grid item xs={12}>
      <Typography fontWeight={600}>Lifestyle Responses: </Typography>
    </Grid>
    {questionsSaved &&  <Grid item xs={12} mt={2}>
      <Typography fontWeight={600}>Answers come from this resident’s previous Matching Round </Typography>
    </Grid>}
    <Grid item xs={12}>
      <UserQuestions />
    </Grid>
  </Grid>
);
